import step1Image from "assets/img/tutorial/step-1.gif";
import step2Image from "assets/img/tutorial/step-2.gif";
import step3Image from "assets/img/tutorial/step-3.png";
import step4Image from "assets/img/tutorial/step-4.gif";
import step5Image from "assets/img/tutorial/step-5.png";
import step6Image from "assets/img/tutorial/step-6.png";
import step7Image from "assets/img/tutorial/step-7.gif";
import step8Image from "assets/img/tutorial/step-8.png";
import step9Image from "assets/img/tutorial/step-9.png";
import step10Image from "assets/img/tutorial/step-10.png";
import {injectable} from "inversify";
import {action, makeAutoObservable, observable} from "mobx";

export interface ITutorialStep {
	title_loco: string;
	title_alt: string;
	text_loco: string;
	text_alt: string;
	image?: string;
}

export interface ITutorialStore {
	onPlay(): void;

	updateStep(step: number): void;

	getIsTutorialViewed(): boolean;

	setTutorialViewed(): void;

	get currentStep(): number;

	get isFirstStep(): boolean;

	get isLastStep(): boolean;

	get isSliderStep(): boolean;

	get steps(): ITutorialStep[];

	clear: () => void;
}

@injectable()
export class TutorialStore implements ITutorialStore {
	@observable private _currentStep: number = 0;
	private readonly storageKey: string = "mlb_spin_tutorial";

	constructor() {
		makeAutoObservable(this);
	}

	get steps(): ITutorialStep[] {
		return [
			{
				title_loco: "tutorial.step_1.title",
				title_alt: "Building your Roster",
				text_loco: "tutorial.step_1.text",
				text_alt:
					"You have <b>9 spins</b> to put together your lineup of <b>5 players - 4 hitters</b> and <b>1 pitcher.</b>",
				image: step1Image,
			},
			{
				title_loco: "tutorial.step_2.title",
				title_alt: "Viewing Stats",
				text_loco: "tutorial.step_2.text",
				text_alt:
					"Click on the name of any player on the wheel to view their yearly stats.",
				image: step2Image,
			},
			{
				title_loco: "tutorial.step_3.title",
				title_alt: "Featured Players",
				text_loco: "tutorial.step_3.text",
				text_alt: `
                    <p>Noticing a symbol attached to your player?</p>
                    <ul>
                        <li>Star: The 10% of players projected to score the most points on that day</li>
                        <li>Fire (pitchers): The next 10% of players projected to score the most points on that day</li>
                        <li>Fire (hitters): Players who have scored an increased amount of points in the last 3 or more games they have played</li>
                        <li>Icy: The 10% of players projected to score the least amount of points on that day</li>
                    </ul>
                `,
				image: step3Image,
			},
			{
				title_loco: "tutorial.step_4.title",
				title_alt: "Add Player",
				text_loco: "tutorial.step_4.text",
				text_alt:
					"After the wheel stops on a player, you have 10 seconds to add them or spin again. If time runs out or your open roster spots are equal to your remaining spins, the player gets added automatically.",
				image: step4Image,
			},
			{
				title_loco: "tutorial.step_5.title",
				title_alt: "Spin Again",
				text_loco: "tutorial.step_5.text",
				text_alt:
					"If you’re thinking of re-spinning make sure to check out some of the other players you missed out at the bottom of the wheel.",
				image: step5Image,
			},
			{
				title_loco: "tutorial.step_6.title",
				title_alt: "Viewing your Roster",
				text_loco: "tutorial.step_6.text",
				text_alt:
					"Once your lineup is set, drop by anytime to see how your players are doing.",
				image: step6Image,
			},
			{
				title_loco: "tutorial.step_7.title",
				title_alt: "Leaderboards",
				text_loco: "tutorial.step_7.text",
				text_alt:
					"At the end of each week, your performance will determine whether you get promoted or demoted based on the points you earned. Regardless of the points you accumulate, you cannot move up or down by more than one league each week.",
				image: step7Image,
			},
			{
				title_loco: "tutorial.step_8.title",
				title_alt: "League",
				text_loco: "tutorial.step_8.text",
				text_alt:
					"Navigate to the leaderboard screen to see how you rank daily and weekly. <br/> <br/> A week runs from Monday to Sunday.",
				image: step8Image,
			},
			{
				title_loco: "tutorial.step_9.title",
				title_alt: "H2H",
				text_loco: "tutorial.step_9.text",
				text_alt:
					"H2H is a fun way to challenge your friends to see who can score the most points in a week. <br/> <br/> A week runs from Monday to Sunday.",
				image: step9Image,
			},
			{
				title_loco: "tutorial.step_10.title",
				title_alt: "Prizes",
				text_loco: "tutorial.step_10.text",
				text_alt: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia, quos.",
				image: step10Image,
			},
		];
	}

	get isFirstStep(): boolean {
		return this._currentStep === 0;
	}

	get isLastStep(): boolean {
		return this._currentStep === this.steps.length + 1;
	}

	get isSliderStep(): boolean {
		return !this.isFirstStep && !this.isLastStep;
	}

	get currentStep(): number {
		return this._currentStep;
	}

	public getIsTutorialViewed(): boolean {
		return JSON.parse(localStorage.getItem(this.storageKey) || "false") as boolean;
	}
	public setTutorialViewed(): void {
		localStorage.setItem(this.storageKey, "true");
	}

	@action
	public onPlay() {
		this._currentStep = 1;
	}

	@action updateStep(step: number) {
		this._currentStep = step;
	}

	@action clear = () => {
		this._currentStep = 0;
	};
}
